import { RedditService } from '../../services/RedditService';
import { Post } from '../../types/post';

export function initMediaGrid() {
  return {
    posts: [] as Post[],
    loading: false,
    loadNextAfter: null as string | null,
    isLoadingMore: false,
    showLoadMore: false,
    loadMoreTimer: null as number | null,
    skeletonCount: 6,

    async fetchPosts() {
      if (this.subreddit === '') return;
      if (this.isLoadingMore) return;

      const isInitialLoad = this.posts.length === 0;
      if (isInitialLoad) {
        this.loading = true;
      } else {
        this.isLoadingMore = true;
      }

      try {
        const { posts, nextAfter } = await this.redditService.fetchPosts(this.subreddit, this.loadNextAfter || '');
        this.loadNextAfter = nextAfter;

        if (this.loadMoreTimer) {
          clearTimeout(this.loadMoreTimer);
        }

        this.loadMoreTimer = setTimeout(() => {
          this.showLoadMore = true;
        }, 2000);

        this.posts = [...this.posts, ...posts];
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        this.isLoadingMore = false;
        this.loading = false;
      }
    },

    handleIntersect(redditService: RedditService, subreddit: string) {
      if (!this.isLoadingMore && this.loadNextAfter) {
        this.fetchPosts();
      }
    },

    hidePost(postId: string) {
      document.querySelector('[data-post-id="' + postId + '"]')?.remove()
    },

    handleMediaGridTouchStart(e: TouchEvent) {
      console.log('touch')
      this.mediaGridTouchStartY = e.touches.length ? e.touches[0].clientY : e.changedTouches[0].clientY;
      this.wasAutoScroll = this.autoScroll
      // stop autoscroll when a swipe is happening
      this.autoScroll = false;
      this.syncAutoScroll()
    },

    handleMediaGridTouchEnd(e: TouchEvent) {
      console.log('touchend', e)
      const endY = e.touches.length ? e.touches[0].clientY : e.changedTouches[0].clientY;
      if (endY > this.mediaGridTouchStartY) {
        return
      }

      if (this.wasAutoScroll) {
        setTimeout(() => {
          this.autoScroll = true;
          this.wasAutoScroll = false;
          this.syncAutoScroll()
        }, 1000)
      }
    },

  };
}
